import { useState, useEffect, useCallback , useRef}  from 'react';
import SignaturePad from 'react-signature-canvas';
import { convertDatetime } from '../controller/utils.js';
import dayjs from 'dayjs';

export  const Firma = ({ firmaData, setFirmaData, user , modify}) => {
  const [modalOpen, setModalOpen] = useState(false);
  
  const sigRef = useRef();
  //console.log("User",user);
  //console.log("FirmaData",firmaData);
  const apriModal = () => setModalOpen(true);
  const chiudiModal = () => setModalOpen(false);

  const confermaFirma = () => {
    const dataUrl = sigRef.current.toDataURL("image/png");
    const datetime=new Date();
    setFirmaData({"src":dataUrl,"datetime":dayjs(datetime).$d,"email":user.email,"uid":user.uid});
    chiudiModal();
  };

  const cancellaFirma = () => {
    sigRef.current.clear();
  };
  const getSignatureDimension = function() {
    const width=Math.min(window.innerWidth - 200, 1024);
    return {"width":width,"height":width/3};
  }
  const [signatureDimension, setSignatureDimension] = useState(getSignatureDimension());
  useEffect(() => {
    const handleResize = () => {
      setSignatureDimension(getSignatureDimension());
    };

    window.addEventListener('resize', handleResize);

    // Cleanup: rimuovi il listener quando il componente viene smontato
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <div>
      {firmaData && (
        <>
          <div>
            <img src={firmaData.src} alt="Firma" style={{ border: "1px solid #ccc", maxWidth: "400px" }} />
            <p>
              Firma acquisita il {dayjs(convertDatetime(firmaData.datetime)).format('DD/MM/YYYY HH:mm:ss')} Utente: {firmaData.email} (uid: {firmaData.uid})
            </p>
            {modify && (
              <>
                {window.innerWidth >= 650 ? (
                  <button onClick={apriModal}>Re-Inserisci Firma</button>
                ) : (
                  <p style={{ color: 'red' }}>Impossibile acquisire firma sul dispositivo corrente</p>
                )}
              </>
            )}
          </div>
        </>
      )}

      {!firmaData && (
        <>
          <p>Firma non acquisita</p>
        </>
      )}
      {!firmaData && modify && (
        <>
          {window.innerWidth >= 650 ? (
            <button onClick={apriModal}>Inserisci Firma</button>
          ) : (
            <p style={{ color: 'red' }}>Impossibile acquisire firma con le impostazioni correnti. Provare a allargare la finestra o a ruotare il dispositivo in orizzontale.</p>
          )}
        </>
      )}
      {modalOpen && (
        <div className="firma-modal-overlay">
          <div className="firma-modal-content">
            <h2>Firma qui</h2>
            <SignaturePad
              ref={sigRef}
              canvasProps={{ width: signatureDimension.width, height: signatureDimension.height, className: "firma-canvas",style: { width: `${signatureDimension.width}px` }, }}
            />
            <div className="firma-modal-buttons">
              <button onClick={cancellaFirma}>Cancella</button>
              <button onClick={chiudiModal}>Annulla</button>
              <button onClick={confermaFirma}>Conferma</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};